module.exports = __webpack_public_path__ + "img/anli03.0111f86d.png";